import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadIx2067ListStatus: 'idle',
    loadIx2067ListError: undefined as any,
    loadIx2067ListLastArgs: undefined as any,
    loadIx2067Status: 'idle',
    loadIx2067Error: undefined as any,
    saveIx2067Status: 'idle',
    saveIx2067Error: undefined as any,
    deleteIx2067Status: 'idle',
    deleteIx2067Error: undefined as any,

    ix2067List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2067List = createAsyncThunk('ix2067Slice/loadIx2067List', async ({ gridFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2067Slice.loadIx2067ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_getustvalaeufe/?BUKREIS=${gridFilters.values.BUKREISFILTER}&OBJRANGE=${gridFilters.values.OBJRANGEFILTER}&VONDATUM=${gridFilters.values.VONDATUMFILTER}&BISDATUM=${gridFilters.values.BISDATUMFILTER}&LETZTELAEUFE=${gridFilters.values.LETZTELAEUFEFILTER}&DATUMMODE=${gridFilters.values.DATUMMODEFILTER}&INCLUDEGELOESCHT=${gridFilters.values.INCLUDEGELOESCHTFILTER}`, undefined)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2067ListStatus } = getState().ix2067Slice
        return loadIx2067ListStatus !== 'pending'
    }
})

export const loadIx2067 = createAsyncThunk('ix2067Slice/loadIx2067', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/ix2067/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2067Status } = getState().ix2067Slice
        return loadIx2067Status !== 'pending'
    }
})

export const saveIx2067 = createAsyncThunk('ix2067Slice/saveIx2067', async ({ ix2067 }: any, { rejectWithValue }: any) => {
    let promises = []
    if (ix2067?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/ix2067/${ ix2067?.HDR_ID }/`,
            prepareData(ix2067),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/ix2067/`,
            prepareData(ix2067),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveIx2067Status } = getState().ix2067Slice
        return saveIx2067Status !== 'pending'
    }
})

export const deleteIx2067 = createAsyncThunk('ix2067Slice/deleteIx2067', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/ix2067/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteIx2067Status } = getState().ix2067Slice
        return deleteIx2067Status !== 'pending'
    }
})

const Ix2067Slice = createSlice({
    name: 'ix2067Slice',
    initialState,
    reducers: {
        resetloadIx2067ListError: (state) => {
            state.loadIx2067ListError = undefined
        },
        resetloadIx2067: (state) => {
            state.formItem = undefined
            state.loadIx2067Error = undefined
        },
        resetloadIx2067Error: (state) => {
            state.loadIx2067Error = undefined
        },
        resetsaveIx2067: (state) => {
            state.formItem = undefined
            state.saveIx2067Error = undefined
        },
        resetsaveIx2067Error: (state) => {
            state.saveIx2067Error = undefined
        },
        resetdeleteIx2067Error: (state) => {
            state.deleteIx2067Error = undefined
        },
        removeFromIx2067ListById: (state, action) => {
            state.ix2067List = state.ix2067List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2067ListByIds: (state, action) => {
            state.ix2067List = state.ix2067List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2067List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2067ListStatus = 'preloaded'
            state.loadIx2067ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2067List = []
            state.loadIx2067ListStatus = 'idle'
            state.loadIx2067ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2067List.pending, (state) => {
            state.loadIx2067ListStatus = 'pending'
            state.loadIx2067ListError = undefined
        })
        builder.addCase(loadIx2067List.fulfilled, (state, action) => {
            state.loadIx2067ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2067ListLastArgs = action.payload.args

            {
                state.ix2067List = action.payload.data

            }
        })
        builder.addCase(loadIx2067List.rejected, (state, action) => {
            state.loadIx2067ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2067ListError = action.error.message
            } else {
                state.loadIx2067ListError = action.payload
            }
        })

        builder.addCase(loadIx2067.pending, (state) => {
            state.loadIx2067Status = 'pending'
            state.loadIx2067Error = undefined
        })
        builder.addCase(loadIx2067.fulfilled, (state, action) => {
            state.loadIx2067Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2067List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2067List.push(newItem) }
                else { state.ix2067List[i] = { ...state.ix2067List[i], ...newItem } }
            }
        })
        builder.addCase(loadIx2067.rejected, (state, action) => {
            state.loadIx2067Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2067Error = action.error.message
            } else {
                state.loadIx2067Error = action.payload
            }
        })

        builder.addCase(saveIx2067.pending, (state) => {
            state.saveIx2067Status = 'pending'
            state.saveIx2067Error = undefined
        })
        builder.addCase(saveIx2067.fulfilled, (state, action) => {
            state.saveIx2067Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.ix2067List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.ix2067List.push(newItem) }
                else { state.ix2067List[i] = { ...state.ix2067List[i], ...newItem } }
            }
        })
        builder.addCase(saveIx2067.rejected, (state, action) => {
            state.saveIx2067Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveIx2067Error = action.error.message
            } else {
                state.saveIx2067Error = action.payload
            }
        })

        builder.addCase(deleteIx2067.pending, (state) => {
            state.deleteIx2067Status = 'pending'
            state.deleteIx2067Error = undefined
        })
        builder.addCase(deleteIx2067.fulfilled, (state, action) => {
            state.deleteIx2067Status = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.ix2067List = state.ix2067List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.ix2067List = state.ix2067List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteIx2067.rejected, (state, action) => {
            state.deleteIx2067Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteIx2067Error = action.error.message
            } else {
                state.deleteIx2067Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx2067ListError,
    resetloadIx2067,
    resetloadIx2067Error,
    resetsaveIx2067,
    resetsaveIx2067Error,
    resetdeleteIx2067Error,
    removeFromIx2067ListById,
    removeFromIx2067ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2067Slice.actions
export default Ix2067Slice.reducer
